var OKMMap = {
  elements: {
    map: null,
    search: null,
    list: null
  },
  locations: [],
  myLocationIcon : '',
  myLocationMarker : null,
  popupContent: '',
  mapAPIKey: 'AIzaSyCzq2leuo5nqi5wIDBL34f7JKKyMZkgKMg',
  map: null,
  infoWindow: null,
  mapBounds: null,
  defaultPos: { lat: 0.0, lng: 0.0 },
  onGetInfoWindowContent: null,
  mapTypeId: '',

  initMap: function()
  {
    if ( "geolocation" in navigator )
    {
      navigator.geolocation.getCurrentPosition( function(position){ this.defaultPos = { lat: position.coords.latitude, lng: position.coords.longitude } } );
    }

    this.mapBounds = new google.maps.LatLngBounds();
    this.infoWindow = new google.maps.InfoWindow();
    this.myLocationMarker = new google.maps.Marker( { icon: this.myLocationIcon } );

    if ( this.mapTypeId == '' ) { this.mapTypeId = google.maps.MapTypeId.ROADMAP; }
    this.map = new google.maps.Map( document.getElementById( this.elements.map ), { mapTypeControlOptions: { mapTypeIds: [] }, zoom: 4, center: this.defaultPos, mapTypeId: this.mapTypeId/*google.maps.MapTypeId.ROADMAP*/, controlSize: 30 } );
    this.map.data.addListener( 'click', this.onClickMarker );
    this.map.data.setStyle( feature => {
      var icon = null;
      var zIndex = 0;
      var visible = true;
      if ( feature.getProperty( 'icon' ) ) {
        icon = feature.getProperty( 'icon' );
      }
      if ( feature.getProperty( 'zIndex' ) ) {
        zIndex = feature.getProperty( 'zIndex' );
      }
      if ( feature.getProperty( 'visible' ) ) {
        visible = feature.getProperty( 'visible' );
      }
      return ( { icon: icon, zIndex: zIndex, visible: visible } );
    });
    
    this.locations.forEach( location => {
      var latlng = new google.maps.LatLng( location.data.lat, location.data.lng );
      this.mapBounds.extend( latlng );
      location.latlng = latlng;

      var markerImage = '';
      if ( typeof location.data.icon === 'object' ){
        markerImage = new google.maps.MarkerImage( location.data.icon.url,
                                      new google.maps.Size( location.data.icon.size.width, location.data.icon.size.height ),
                                      new google.maps.Point( 0, 0 ),
                                      new google.maps.Point( location.data.icon.point.x, location.data.icon.point.y ) );
      } else { markerImage = location.data.icon; }
        
      this.map.data.addGeoJson( {
        "id": location.id,
        "geometry": {
          "type": "Point",
          "coordinates": [ location.data.lng, location.data.lat ]
        },
        "type": "Feature",
        "properties": {
          "id": location.id,
          "icon": location.data.icon,
          "zIndex": location.data.zIndex,
          "visible": location.data.visible
        }
      }, 'id' );

    });
    this.orderListItems();
    this.map.fitBounds( this.mapBounds );

    if ( this.elements.search )
    {
      const input = document.getElementById( this.elements.search );
      const autocomplete = new google.maps.places.Autocomplete( input );
    

///
    /* Store original event listener */
    const _addEventListener = input.addEventListener

    const addEventListenerWrapper = (type, listener) => {
      if (type === 'keydown') {
        /* Store existing listener function */
        const _listener = listener
        listener = (event) => {
          /* Simulate a 'down arrow' keypress if no address has been selected */
          const suggestionSelected = document.getElementsByClassName('pac-item-selected').length;
          if (event.key === 'Enter' && !suggestionSelected) {
            const e = new KeyboardEvent('keydown', { 
              key: 'ArrowDown', 
              code: 'ArrowDown', 
              keyCode: 40, 
            })
            _listener.apply(input, [e])
          }
          _listener.apply(input, [event])
        }
      }
      _addEventListener.apply(input, [type, listener])
    }

    input.addEventListener = addEventListenerWrapper;
///

      autocomplete.bindTo( "bounds", this.map );
      //autocomplete.setTypes( [ "(regions)" ] );
      autocomplete.addListener( "place_changed", () => {
  
        this.infoWindow.close();
        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          //window.alert("No details available for input: '" + place.name + "'");
          this.myLocationMarker.setMap( null );
          this.map.fitBounds( this.mapBounds );
          this.orderListItems();
          return;
        }

        // If the place has a geometry, then present it on a map.
        if ( place.geometry.viewport ) {
          this.map.fitBounds( place.geometry.viewport );
          this.myLocationMarker.setPosition( place.geometry.viewport.getCenter() );
          this.myLocationMarker.setMap( this.map );
        } else {
          this.map.setCenter( place.geometry.location );
          this.myLocationMarker.setPosition( place.geometry.location );
          this.myLocationMarker.setMap( this.map );
        }
        
        // Calculate distances to all location to find nearest
        let d = -1;
        let item = null; // stores the item with smallest distance
        this.locations.forEach( location => {
          location.distance = this.getDistance( { data: { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() } }, location );

    let obj = document.querySelector('[data-id="' + location.id + '"]');      
    if ( obj ) {
      obj.setAttribute( 'data-distance', location.distance );
      obj.style.order = '' + Math.round( location.distance );
    }
          
          if ( ( d < 0 ) || ( d > location.distance ) ) {
            d = location.distance;
            item = location;
          }
        });

        if ( item ) {
          let mapBounds = this.map.getBounds();
          mapBounds.extend( { lat: item.data.lat, lng: item.data.lng } );
          this.map.fitBounds( mapBounds );
          this.selectItem( item.id );
        }

      });
    }
  },

  getDistance: function( location_1, location_2 )
  {
    var R = 3958.8; // Radius of the Earth in miles
    var rlat1 = location_1.data.lat * ( Math.PI / 180 ); // Convert degrees to radians
    var rlat2 = location_2.data.lat * ( Math.PI / 180 ); // Convert degrees to radians
    var difflat = rlat2 - rlat1; // Radian difference (latitudes)
    var difflon = ( location_2.data.lng - location_1.data.lng ) * ( Math.PI / 180 ); // Radian difference (longitudes)

    var d = 2 * R * Math.asin( Math.sqrt( Math.sin( difflat / 2 ) * Math.sin( difflat / 2 ) + Math.cos( rlat1 ) * Math.cos( rlat2 ) * Math.sin( difflon / 2 ) * Math.sin( difflon / 2 ) ) );
    return d;
  },

  onClickMarker: function( event )
  {
    const id = event.feature.getProperty( 'id' );
    OKMMap.showInfoWindow( OKMMap.getLoctionById( id ) );
    OKMMap.selectItem( id );
  },

  orderListItems: function()
  {
    let locations = document.getElementsByClassName( "map-list-item" );
    for ( i = 0; i < locations.length; i++ ) {
      locations[i].style.order = locations[i].getAttribute( 'data-order' );
    };
  },
  
  selectItem: function( id )
  {
    let obj = document.querySelectorAll('[data-id]');
    if ( obj ) {
      obj.forEach( (o) => { o.classList.remove('map-list-item-active') } );
    }

    obj = document.querySelector('[data-id="' + id + '"]');
    if ( obj ) {
      obj.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      obj.classList.add('map-list-item-active');
    }
  },
  
  showInfoWindow: function( location )
  {
    if ( this.onGetInfoWindowContent )
    {
      const content = this.onGetInfoWindowContent( this.infoWindow, location );

      this.infoWindow.setContent( content );
      this.infoWindow.setPosition( { lat: location.data.lat, lng: location.data.lng } );
      this.infoWindow.setOptions( { pixelOffset: new google.maps.Size( 0, -30 ) } );
      this.infoWindow.open( this.map );
    }
  },

  addLocation: function( id, data )
  {
    this.locations.unshift( { id: id, data: data, distance: null } );
  },

  getLoctionById: function( id )
  {
    for ( i = 0; i < this.locations.length; i++ )
    {
      if ( this.locations[ i ].id == id ) return this.locations[ i ];
    }
    return null;
  },
      
  onClickItem: function( e )
  {
    const location = this.getLoctionById( e.dataset.id );
    if ( location )
    {
      this.infoWindow.close();
      this.map.panTo( { lat: location.data.lat, lng: location.data.lng } );
      this.showInfoWindow( location );
      this.selectItem( e.dataset.id );
    }

  },

  stopPropagation: function( e )
  {
    e = e || window.event;
    e.cancelBubble = true;
    e.stopPropagation();
  }

}